import { globalObject } from '../globalObject';
export function getBundleId(appName) {
  return globalObject === null || globalObject === void 0 ? void 0 : globalObject[`__faroBundleId_${appName}`];
}